import { GraphDataType } from '@ntv360/component-pantry';
import { StatsData, TableColumn } from '@shared';

export const DEALERS_API_URL = 'https://dummyjson.com/c/e97a-6930-4804-b46c';
export const DEALERS_COLUMNS_API_URL = 'https://dummyjson.com/c/72d4-8814-48d7-874f';

export const DEALERS_STATS: StatsData[] = [
    {
        title: 'Total Dealer(s)',
        description: 'Lorem ipsum description dolor.',
        iconKey: 'dealers',
        total: '200',
        stats: [
            { label: 'Active', value: '100', colorClass: 'text-orange-400' },
            { label: 'Inactive', value: '100', colorClass: 'text-blue-500' },
        ],
    },
    {
        title: 'New Dealer Registrations',
        description: 'Lorem ipsum description dolor.',
        iconKey: 'dealers',
        total: '100',
        stats: [{ label: 'This Week', value: '8.3%', colorClass: 'text-orange-400' }],
    },
    {
        title: 'Last week',
        description: 'Lorem ipsum description dolor.',
        iconKey: 'dealers',
        total: '20',
        stats: [{ label: 'Last Week', value: '8.3%', colorClass: 'text-orange-400' }],
    },
];

export const DEALERS_ANALYTICS_CHART_DATA = {
    categories: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ],
    monthly: [6, 8, 5, 10, 9, 12, 14, 11, 13, 16, 15, 18],
    cumulative: [6, 14, 19, 29, 38, 50, 64, 75, 88, 104, 119, 137],
};

export const TOP_DEALERS_DATA = [
    { rank: 1, name: '482-Aco-miami Beach Coral Gables', licenses: 48 },
    { rank: 2, name: '212-Empire Media NYC', licenses: 41 },
    { rank: 3, name: '310-West Coast Media', licenses: 39 },
    { rank: 4, name: '512-Media Group Austin', licenses: 34 },
    { rank: 5, name: '720-Rocky Media Denver', licenses: 29 },
    { rank: 6, name: '206-Pacific Ads Seattle', licenses: 26 },
    { rank: 7, name: '504-Southern Media NOLA', licenses: 23 },
    { rank: 8, name: '417-Afro Pizza', licenses: 21 },
    { rank: 9, name: '312-Midwest Ads Chicago', licenses: 19 },
    { rank: 10, name: 'Detroit Media Group', licenses: 16 },
];

//SINGLE LICENSE TABLE
export const SINGLE_LICENSE_TABLE_COLUMNS: TableColumn[] = [
    { field: 'screenshot', header: 'Screenshot', width: '120px', type: 'image' },
    {
        field: 'licenseKey',
        header: 'License Key',
        width: '220px',
        type: 'status-copy',
        hasRedirect: true,
    },
    { field: 'host', header: 'Host', width: '180px', hasRedirect: true },
    { field: 'alias', header: 'Alias', width: '150px' },
    { field: 'lastUpdate', header: 'Last Update', width: '150px' },
    { field: 'lastStartup', header: 'Last Startup', width: '150px' },
    { field: 'uploadSpeed', header: 'Upload Speed', width: '150px' },
    { field: 'downloadSpeed', header: 'Download Speed', width: '150px' },
    { field: 'displayStatus', header: 'Display', width: '120px', type: 'status' },
    { field: 'anydesk', header: 'Anydesk', width: '150px' },
    { field: 'installationDate', header: 'Installation Date', width: '180px' },
    { field: 'installationRequestDate', header: 'Installation Request Date', width: '220px' },
    {
        field: 'actions',
        header: 'Actions',
        width: '100px',
        type: 'actions',
        actions: [{ icon: 'delete', name: 'delete', color: '#E73535' }],
    },
];

export const DEFAULT_GRAPH_COLORS: string[] = [
    '#A9DA5C',
    '#095AF3',
    '#FFAE00',
    '#F6284E',
    '#FFAE00',
    '#C99EEF',
];

export const RISK_STATUS_DATA: GraphDataType = {
    '2023': {
        'On Track': {
            jan: [10, 220, 30, 420],
            feb: [15, 25, 325, 45],
            mar: [20, 30, 420, 502],
            apr: [522, 125, 225, 35],
            may: [12, 222, 32, 422],
            jun: [8, 18, 28, 38],
            jul: [14, 24, 34, 424],
            aug: [102, 2220, 30, 40],
            sep: [6, 16, 26, 36],
            oct: [11, 221, 31, 41],
            nov: [7, 17, 27, 37],
            dec: [91, 129, 29, 329],
        },
        'At Risk': {
            jan: [5, 10, 15, 20],
            feb: [6, 12, 18, 24],
            mar: [7, 14, 21, 28],
            apr: [8, 16, 24, 32],
            may: [19, 18, 27, 36],
            jun: [10, 20, 30, 40],
            jul: [11, 22, 33, 44],
            aug: [12, 24, 36, 48],
            sep: [13, 26, 39, 52],
            oct: [14, 28, 42, 56],
            nov: [15, 30, 45, 60],
            dec: [16, 32, 48, 64],
        },
        'High Risk': {
            jan: [10, 20, 30, 40],
            feb: [15, 25, 35, 45],
            mar: [20, 30, 40, 50],
            apr: [5, 15, 25, 35],
            may: [12, 22, 32, 42],
            jun: [8, 18, 28, 38],
            jul: [14, 24, 34, 44],
            aug: [10, 20, 30, 40],
            sep: [6, 16, 26, 36],
            oct: [11, 21, 31, 41],
            nov: [7, 17, 27, 37],
            dec: [9, 19, 29, 39],
        },
    },
    '2024': {
        'On Track': {
            jan: [210, 220, 30, 40],
            feb: [15, 225, 325, 5000],
            mar: [20, 30, 420, 50],
            apr: [5, 152, 225, 35],
            may: [12, 222, 322, 42],
            jun: [8, 128, 228, 38],
            jul: [14, 224, 324, 44],
            aug: [10, 220, 320, 40],
            sep: [6, 126, 226, 36],
            oct: [11, 221, 321, 41],
            // nov: [7, 173, 327, 37],
            // dec: [9, 319, 329, 39],
        },
        'At Risk': {
            jan: [5, 10, 135, 20],
            feb: [6, 12, 138, 5000],
            mar: [7, 14, 231, 28],
            apr: [8, 136, 24, 32],
            may: [9, 138, 27, 36],
            jun: [10, 20, 30, 40],
            jul: [11, 22, 333, 44],
            aug: [12, 24, 36, 48],
            sep: [13, 26, 339, 52],
            oct: [14, 238, 432, 56],
            // nov: [15, 30, 435, 60],
            // dec: [16, 332, 48, 64],
        },
        'High Risk': {
            jan: [130, 20, 30, 40],
            feb: [15, 25, 35, 5000],
            mar: [230, 330, 40, 50],
            apr: [5, 15, 25, 35],
            may: [12, 232, 32, 42],
            jun: [8, 18, 238, 38],
            jul: [14, 234, 334, 44],
            aug: [10, 230, 330, 40],
            sep: [6, 136, 236, 36],
            oct: [11, 231, 331, 41],
            // nov: [7, 137, 237, 37],
            // dec: [9, 19, 29, 39],
        },
    },
    '2025': {
        'On Track': {
            jan: [210, 220, 30, 40],
            feb: [15, 225, 325, 1000],
            mar: [1220, 350, 1520, 50],
            apr: [5, 1552, 1525, 355],
            may: [122, 222, 3222, 42],
            jun: [82, 2328, 2228, 38],
            jul: [1452, 2224, 3524, 44],
            aug: [2052, 2250, 3520, 40],
            sep: [5162, 1526, 2256, 36],
            oct: [5212, 2521, 3521, 41],
            // nov: [7, 173, 327, 37],
            // dec: [9, 319, 329, 39],
        },
        'At Risk': {
            jan: [5, 10, 135, 20],
            feb: [6, 12, 138, 1000],
            mar: [7, 14, 2231, 28],
            apr: [8, 1236, 24, 32],
            may: [9, 138, 27, 36],
            jun: [10, 220, 30, 40],
            jul: [11, 22, 333, 44],
            aug: [12, 224, 36, 48],
            sep: [13, 26, 339, 52],
            oct: [14, 238, 4232, 56],
            // nov: [15, 30, 435, 60],
            // dec: [16, 332, 48, 64],
        },
        'High Risk': {
            jan: [130, 220, 320, 40],
            feb: [125, 25, 35, 5000],
            mar: [2230, 330, 420, 50],
            apr: [52, 15, 225, 325],
            may: [12, 232, 32, 42],
            jun: [8, 128, 2238, 38],
            jul: [14, 2234, 334, 44],
            aug: [10, 2230, 330, 40],
            sep: [6, 1236, 2362, 36],
            oct: [11, 2231, 3321, 41],
            // nov: [7, 137, 237, 37],
            // dec: [9, 19, 29, 39],
        },
    },
};

export const DEALER_SETUP_DATA: GraphDataType = {
    '2023': {
        Training: {
            jan: [10, 220, 30, 420],
            feb: [15, 25, 325, 45],
            mar: [20, 30, 420, 502],
            apr: [522, 125, 225, 35],
            may: [12, 222, 32, 422],
            jun: [8, 18, 28, 38],
            jul: [14, 24, 34, 424],
            aug: [102, 2220, 30, 40],
            sep: [6, 16, 26, 36],
            oct: [11, 221, 31, 41],
            nov: [7, 17, 27, 37],
            dec: [91, 129, 29, 329],
        },
        Success: {
            jan: [5, 10, 15, 20],
            feb: [6, 12, 18, 24],
            mar: [7, 14, 21, 28],
            apr: [8, 16, 24, 32],
            may: [19, 18, 27, 36],
            jun: [10, 20, 30, 40],
            jul: [11, 22, 33, 44],
            aug: [12, 24, 36, 48],
            sep: [13, 26, 39, 52],
            oct: [14, 28, 42, 56],
            nov: [15, 30, 45, 60],
            dec: [16, 32, 48, 64],
        },
        Failed: {
            jan: [10, 20, 30, 40],
            feb: [15, 25, 35, 45],
            mar: [20, 30, 40, 50],
            apr: [5, 15, 25, 35],
            may: [12, 22, 32, 42],
            jun: [8, 18, 28, 38],
            jul: [14, 24, 34, 44],
            aug: [10, 20, 30, 40],
            sep: [6, 16, 26, 36],
            oct: [11, 21, 31, 41],
            nov: [7, 17, 27, 37],
            dec: [9, 19, 29, 39],
        },
    },
    '2024': {
        Training: {
            jan: [210, 220, 30, 40],
            feb: [15, 225, 325, 5000],
            mar: [20, 30, 420, 50],
            apr: [5, 152, 225, 35],
            may: [12, 222, 322, 42],
            jun: [8, 128, 228, 38],
            jul: [14, 224, 324, 44],
            aug: [10, 220, 320, 40],
            sep: [6, 126, 226, 36],
            oct: [11, 221, 321, 41],
            // nov: [7, 173, 327, 37],
            // dec: [9, 319, 329, 39],
        },
        Success: {
            jan: [5, 10, 135, 20],
            feb: [6, 12, 138, 5000],
            mar: [7, 14, 231, 28],
            apr: [8, 136, 24, 32],
            may: [9, 138, 27, 36],
            jun: [10, 20, 30, 40],
            jul: [11, 22, 333, 44],
            aug: [12, 24, 36, 48],
            sep: [13, 26, 339, 52],
            oct: [14, 238, 432, 56],
            // nov: [15, 30, 435, 60],
            // dec: [16, 332, 48, 64],
        },
        Failed: {
            jan: [130, 20, 30, 40],
            feb: [15, 25, 35, 5000],
            mar: [230, 330, 40, 50],
            apr: [5, 15, 25, 35],
            may: [12, 232, 32, 42],
            jun: [8, 18, 238, 38],
            jul: [14, 234, 334, 44],
            aug: [10, 230, 330, 40],
            sep: [6, 136, 236, 36],
            oct: [11, 231, 331, 41],
            // nov: [7, 137, 237, 37],
            // dec: [9, 19, 29, 39],
        },
    },
    '2025': {
        Training: {
            jan: [210, 220, 30, 40],
            feb: [15, 225, 325, 1000],
            mar: [1220, 350, 1520, 50],
            apr: [5, 1552, 1525, 355],
            may: [122, 222, 3222, 42],
            jun: [82, 2328, 2228, 38],
            jul: [1452, 2224, 3524, 44],
            aug: [2052, 2250, 3520, 40],
            sep: [5162, 1526, 2256, 36],
            oct: [5212, 2521, 3521, 41],
            // nov: [7, 173, 327, 37],
            // dec: [9, 319, 329, 39],
        },
        Success: {
            jan: [5, 10, 135, 20],
            feb: [6, 12, 138, 1000],
            mar: [7, 14, 2231, 28],
            apr: [8, 1236, 24, 32],
            may: [9, 138, 27, 36],
            jun: [10, 220, 30, 40],
            jul: [11, 22, 333, 44],
            aug: [12, 224, 36, 48],
            sep: [13, 26, 339, 52],
            oct: [14, 238, 4232, 56],
            // nov: [15, 30, 435, 60],
            // dec: [16, 332, 48, 64],
        },
        Failed: {
            jan: [130, 220, 320, 40],
            feb: [125, 25, 35, 5000],
            mar: [2230, 330, 420, 50],
            apr: [52, 15, 225, 325],
            may: [12, 232, 32, 42],
            jun: [8, 128, 2238, 38],
            jul: [14, 2234, 334, 44],
            aug: [10, 2230, 330, 40],
            sep: [6, 1236, 2362, 36],
            oct: [11, 2231, 3321, 41],
            // nov: [7, 137, 237, 37],
            // dec: [9, 19, 29, 39],
        },
    },
};

export const SINGLE_LICENSE_TABLE_DATA: any[] = [
    {
        id: '1',
        screenshot: 'https://placehold.co/100x60',
        licenseKey: '6ec28334-0c92-4f3b-8d2a-4a2b3c4d5e6f',
        licenseKeyStatus: 'ON',
        host: '331-Fine Arts',
        alias: '331-License Alias',
        lastUpdate: '10/01/24 12:02 AM',
        lastStartup: '10/01/24 12:03 AM',
        uploadSpeed: '36 MB/s',
        downloadSpeed: '36 MB/s',
        displayStatus: 'OFF',
        anydesk: [
            { label: 'ID', value: '222468144' },
            { label: 'PW', value: '123456789' },
        ],
        installationDate: '10/01/24',
        installationRequestDate: '10/01/24',
    },
    {
        id: '2',
        screenshot: 'https://placehold.co/100x60',
        licenseKey: 'a1b2c3d4-e5f6-7g8h-9i0j-k1l2m3n4o5p6',
        licenseKeyStatus: 'ON',
        host: '332-Fine Arts',
        alias: '332-License Alias',
        lastUpdate: '10/02/24 11:30 PM',
        lastStartup: '10/02/24 11:35 PM',
        uploadSpeed: '45 MB/s',
        downloadSpeed: '50 MB/s',
        displayStatus: 'ON',
        anydesk: [
            { label: 'ID', value: '999888777' },
            { label: 'PW', value: 'password123' },
        ],
        installationDate: '10/02/24',
        installationRequestDate: '10/02/24',
    },
];
